<template>
  <div class="login index">
    <img class="bg" src="http://img.wish.hebyun.com.cn/images/login_bg.jpg" />
    <div class="header">
      <div class="title_big">党员帮办微心愿</div>
      <div class="title_small">欢迎登录~</div>
    </div>
    <div class="form_section">
      <div class="form_item">
        <input placeholder="请输入账号" v-model="account" />
      </div>
      <div class="form_item">
        <input placeholder="请输入密码" v-model="password" type="password" />
      </div>
    </div>
    <img
      class="bgbottom"
      src="http://img.wish.hebyun.com.cn/images/login_bg_footer.png"
    />
    <Button :button="button" @click.native="login" />
  
  </div>
</template>

<script>
import Button from "@/components/Button";

export default {
  name: "login",
  data() {
    return {
      account: "",
      password: "",
      button: "登录",
    };
  },
  components: {
    Button
  },
  mounted() {},
  methods: {
    async login() {
      if (this.account.trim().length === 0) {
        this.$toast("请输入账号");
        return;
      }
      if (this.password.trim().length === 0) {
        this.$toast("请输入密码");
        return;
      }
      let data = {
        account: this.account,
        password: this.password,
      };
      await this.$api.organLogin(data);
      await this.$api.queryUserInfo();
      this.$toast("登录成功");
      setTimeout(() => {
        this.$router.push("./mine");
      }, 2000);
    },
  },
};
</script>
<style lang="scss">
.login {
  .btn {
    width: 300px !important;
    height: 42px !important;
    margin-top: 134px !important;
  }
}
</style>
<style scoped lang="scss">
.index {
  width: 100%;
  position: relative;
  height: 100vh;
  overflow: hidden;
  background-color: #ffffff !important;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  .bgbottom {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
  .header {
    position: relative;
    width: 100%;
    text-align: center;
    padding-top: 50px;
    padding-bottom: 20px;
    color: #ffffff;
    .title_big {
      font-size: 31px;
      margin-bottom: 13px;
    }

    .title_small {
      font-size: 21px;
    }
  }

  .form_section {
    padding: 0 37.5px;
    box-sizing: border-box;
    position: relative;
    .form_item {
      padding-top: 35px;
      input::-webkit-input-placeholder {
        color: rgba(202, 9, 8, 0.6);
      }
      input {
        display: block;
        width: 100%;
        background-color: transparent;
        border: none;
        outline: none;
        font-size: 14px;
        color: #cb0a08;
        padding-bottom: 8px;
        padding-top: 13px;
        border-bottom: 1px solid rgba(202, 9, 8, 0.6);
      }
    }
  }

  .register_btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 42px;
    margin: 100px auto 0;
    img {
      width: 300px;
      height: 42px;
      background-image: linear-gradient(0deg, #e10019 0%, #f5531a 100%);
      box-shadow: 0px 1.5px 6px 0px rgba(203, 10, 8, 0.26);
      border-radius: 40px;
    }
    span {
      position: absolute;
      font-size: 18px;
      color: #f8f3cd;
    }
  }
}
</style>
